import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
import { cva } from 'class-variance-authority';
import * as React from 'react';
const badgeVariants = cva('focus:ring-ring inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-semibold transition-colors focus:ring-2 focus:ring-offset-2 focus:outline-none', {
    variants: {
        variant: {
            default: 'bg-primary text-primary-foreground border-transparent',
            secondary: 'bg-secondary text-secondary-foreground border-transparent',
            destructive: 'bg-destructive text-destructive-foreground border-transparent',
            outline: 'text-foreground',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
export function Badge({ className, variant, ...props }) {
    return _jsx("div", { className: cn(badgeVariants({ variant }), className), ...props });
}
